import React from "react";
import styled from "styled-components";

export default styled.div`
    text-align: center;
    > img {
        margin-bottom: 10px;
        width: 50px;
        height: 50px;
        margin-top: 40px;
    }
    h3 {
        color: #5562C0;
        font-size: 26px;
        font-weight: 700;
        text-align: center;
    }
    p {
        font-size: 18px;
        width: 476px;
        margin: 25px auto;
        color: #515151;
        line-height: 24px;
        text-align: center;
    }

    > div {
        text-align: center;
        width: 100%;
        display: block;
        overflow: auto;
    }

    small {
        font-size: 16px;
        line-height: 24px;
        text-align: center;

        a {
            color: #6A6D90;
            text-decoration: underline;
            margin-bottom: 25px;
        }
    }
    button {
        background: #5562c0;
        color: white;
        height: 53px;
        font-size: 20px;
        font-weight: 600;
        border: 0;
        text-align: center;
        margin-top: 33px;
        padding: 0 24px;
        margin: 0 5px;

        &:nth-child(1) {
            color: #8C8FA8;
            background: white;
        }

        img {
            margin-left: 12px;
            width: 7px;
        }
    }
`;